<template>
  <div>
    <LeSet />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import LeSet from '@/components/LeSet.vue'


export default {
  name: 'Home',
  //apollo: {
  //},
  props: {
    setnr: String
  },
  components: {
    LeSet,
    //HelloWorld
  }
}
</script>
